export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e508514a4a611fd559b2a6a6280a4e9da03f4bc7&name=revalidateCommunity!'